import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  import DefaultLayout from "/opt/build/repo/src/components/layout.js";
import Image from "../components/image";
import SEO from "../components/seo";
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = DefaultLayout;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)} components={components}>


      <SEO />
      <section>
        <MDXTag name="p" components={components}>{`Following `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://blog.rayriffy.com/review-the-stupid-hackathon-th-2/"
          }}>{`the`}</MDXTag>{` `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://medium.com/teamappman/%E0%B8%A1%E0%B8%B2%E0%B9%80%E0%B8%A5%E0%B9%88%E0%B8%B2%E0%B8%87%E0%B8%B2%E0%B8%99-the-stupid-hackathon-thailand-2-%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%AD%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B1%E0%B8%99%E0%B8%84%E0%B9%88%E0%B8%B0-a6310bbe47e4"
          }}>{`tremendous`}</MDXTag>{` `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://gitlab.com/StupidHackTH/3/wikis/StupidHackTH2-Feedback"
          }}>{`success`}</MDXTag>{`
of The Stupid Hackathon Thailand #2, we are coming back in `}<MDXTag name="strong" components={components} parentName="p">{`The Stupid Hackathon Thailand #3`}</MDXTag>{`!`}</MDXTag>
      </section>
      <section>
        <MDXTag name="h2" components={components}>{`What is The Stupid Hackathon Thailand?`}</MDXTag>
        <MDXTag name="p" components={components}>{`Bring on your crazy ideas!!!`}</MDXTag>
        <MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`The Stupid Hackathon Thailand`}</MDXTag>{` is a 2-day hackathon with `}<MDXTag name="em" components={components} parentName="p">{`no competition or focus on business value whatsoever`}</MDXTag>{`.
Just come join us and have fun building cool silly crazy stupid projects together!`}</MDXTag>
        <MDXTag name="p" components={components}>{`The Stupid Hackathon is `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://gist.github.com/cheeaun/c3fe6cbb11aef1e146a3474dccf63b87"
          }}>{`held all around the world`}</MDXTag>{`,
including
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://www.stupidhackathon.com/"
          }}>{`New York`}</MDXTag>{` (the original),
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://stupidhackathon.github.io/"
          }}>{`San Francisco`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://steamwith.us/useless/"
          }}>{`Rhode Island`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://stupidhacktoronto.com/"
          }}>{`Canada`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://www.stupidhackathon.wtf/"
          }}>{`Netherlands`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://stupidhackathon.de/"
          }}>{`Ger`}</MDXTag><MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://www.stupidhackcologne.wtf/"
          }}>{`many`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://stupidhackathon.at/"
          }}>{`Austria`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://www.stupidhackathon.se/"
          }}>{`Sweden`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://stupidhackath.no/"
          }}>{`Norway`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://stupidshitnooneinhawaiineedshackathon.github.io/"
          }}>{`Hawaii`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://stupidhackathon.uk/"
          }}>{`UK`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://stupidhackathonsh.github.io/"
          }}>{`Shanghai`}</MDXTag>{`,
`}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://supersillyhackathon.sg/"
          }}>{`Singapore`}</MDXTag>{`,
and… here, `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://stupidhackth.github.io/"
          }}>{`Thailand`}</MDXTag>{`!`}</MDXTag>
      </section>
      <section>
        <MDXTag name="h2" components={components}>{`Ideas`}</MDXTag>
        <MDXTag name="p" components={components}>{`Got no idea? Here’s a sample of what we did last year…`}</MDXTag>
        <section className="index-ideas">
          <MDXTag name="ul" components={components}>
            <MDXTag name="li" components={components} parentName="ul">
              <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://kabkhaw.0002011.xyz/"
                }}><MDXTag name="strong" components={components} parentName="a">{`Kab-Khaw`}</MDXTag></MDXTag>{`
Picks you a random food to eat, when you don’t know what to eat!`}</MDXTag>
            </MDXTag>
            <MDXTag name="li" components={components} parentName="ul">
              <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://web.facebook.com/StupidHackTH/videos/680386978960878/"
                }}><MDXTag name="strong" components={components} parentName="a">{`Stupify`}</MDXTag></MDXTag>{`
A LINE bot that helps stupid boyfriends understand their girlfriends better, especially when she’s mad at you!`}</MDXTag>
            </MDXTag>
            <MDXTag name="li" components={components} parentName="ul">
              <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://medium.com/teamappman/%E0%B8%A1%E0%B8%B2%E0%B9%80%E0%B8%A5%E0%B9%88%E0%B8%B2%E0%B8%87%E0%B8%B2%E0%B8%99-the-stupid-hackathon-thailand-2-%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%AD%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B8%81%E0%B8%B1%E0%B8%99%E0%B8%84%E0%B9%88%E0%B8%B0-a6310bbe47e4"
                }}><MDXTag name="strong" components={components} parentName="a">{`Shabu Shit`}</MDXTag></MDXTag>{`
Mobile app to keep track of your Shabu-Shabu eating achievements!
Can you eat at 100 different Shabu-Shabu restaurants in 1 year?`}</MDXTag>
            </MDXTag>
            <MDXTag name="li" components={components} parentName="ul">
              <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://github.com/internet-destroyer/internet-destroyer"
                }}><MDXTag name="strong" components={components} parentName="a">{`Internet Destroyer`}</MDXTag></MDXTag>{`
Chrome browser extension that lets you invade and destroy the internet!`}</MDXTag>
            </MDXTag>
            <MDXTag name="li" components={components} parentName="ul">
              <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://muay.netlify.com/"
                }}><MDXTag name="strong" components={components} parentName="a">{`Muay Lumken`}</MDXTag></MDXTag>{`
Web app to analyze or randomize a lucky phone number using Super F*cking Advanced Heuristic Black Magic Rule Engine!
(`}<MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://github.com/StupidHackTH/muay-lumken"
                }}>{`GitHub`}</MDXTag>{`)`}</MDXTag>
            </MDXTag>
            <MDXTag name="li" components={components} parentName="ul">
              <MDXTag name="p" components={components} parentName="li"><MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://bangkokipsum.app/"
                }}><MDXTag name="strong" components={components} parentName="a">{`Bangkok Ipsum`}</MDXTag></MDXTag>{`
Web app that generates a random Thai text.
(`}<MDXTag name="a" components={components} parentName="p" props={{
                  "href": "https://github.com/dtinth/bangkokipsum"
                }}>{`GitHub`}</MDXTag>{`)`}</MDXTag>
            </MDXTag>
          </MDXTag>
        </section>
        <MDXTag name="p" components={components}>{`Check out `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "http://www.stupidhackathon.com/"
          }}>{`the original New York Stupid Hackathon’s website`}</MDXTag>{` for more crazy ideas!!!`}</MDXTag>
      </section>
      <section>
        <MDXTag name="h2" components={components}>{`When and Where?`}</MDXTag>
        <MDXTag name="p" components={components}>{`Glad you asked!`}</MDXTag>
        <MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`We are still setting up the event`}</MDXTag>{` —
looking for staffs, sponsors, venues, and working on other preparation work.
We will post new information as they are available.
If you’d like to help/contribute or have more questions,
please `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://m.me/dtinth"
          }}>{`message Thai on Facebook`}</MDXTag>{`.
Check out the `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "information-portal"
          }}>{`information portal`}</MDXTag>{` for more information, including behind-the-scene stuff.`}</MDXTag>
        <MDXTag name="p" components={components}>{`We aim for some time after Songkran Day.`}</MDXTag>
        <MDXTag name="p" components={components}>{`Don’t miss out on updates, `}<MDXTag name="a" components={components} parentName="p" props={{
            "href": "https://web.facebook.com/StupidHackTH/"
          }}>{`like and follow us on Facebook`}</MDXTag>{`!`}</MDXTag>
      </section>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      